import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack'; // externe avant interne
import Request from '../../utils/Request';

// ----------------------------------------------------------------

export const getTransactions = createAsyncThunk(
  'transaction/getTransactions',
  async (params) => {
    const response = await Request.getTransactions(params);
    return response.data;
  }
);

export const getTransaction = createAsyncThunk(
  'transaction/getTransaction',
  async (id) => {
    const response = await Request.getTransaction(id);
    return response.data;
  }
);

export const createTransaction = createAsyncThunk(
  'transaction/createTransaction',
  async (data) => {
    const response = await Request.createTransaction(data);
    return response.data;
  }
);

export const updateTransaction = createAsyncThunk(
  'transaction/updateTransaction',
  async ({ id, ...data }) => {
    const response = await Request.updateTransaction(id, data);
    return response.data;
  }
);

export const deleteTransaction = createAsyncThunk(
  'transaction/deleteTransaction',
  async (id) => {
    await Request.deleteTransaction(id);
    return id;
  }
);

// ----------------------------------------------------------------

const initialState = {
  transactions: [],
  transaction: null,
  isLoading: false,
  error: null
};

const slice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // getTransactions
      .addCase(getTransactions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTransactions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.transactions = action.payload;
      })
      .addCase(getTransactions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // getTransaction
      .addCase(getTransaction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.transaction = action.payload;
      })
      .addCase(getTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // updateTransaction
      .addCase(updateTransaction.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.transaction = action.payload;
        const index = state.transactions.findIndex(t => t.id === action.payload.id);
        if (index !== -1) state.transactions[index] = action.payload;
      })
      .addCase(updateTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // deleteTransaction
      .addCase(deleteTransaction.fulfilled, (state, action) => {
        state.transactions = state.transactions.filter(t => t.id !== action.payload);
        if (state.transaction?.id === action.payload) state.transaction = null;
      });
  }
});

export default slice.reducer;